<template>
	<div class="change-password">
		<form class="change-password__form" @submit.prevent="resetPassword">
			<div class="change-password__inputs">
				<BaseInput
					class="change-password__input"
					v-model="passwordData.currentPassword"
					type="password"
					:label="`${$t('Current password')}:`"
				/>
				<BaseInput
					class="change-password__input"
					v-model="passwordData.newPassword"
					type="password"
					:label="`${$t('New password')}:`"
				/>
				<BaseInput
					class="change-password__input"
					v-model="passwordData.confirmPassword"
					type="password"
					:label="`${$t('Confirm new password')}:`"
				/>
			</div>
			<div class="change-password__wrapper">
				<p v-if="errorMessage" class="change-password__error-message">
					{{ errorMessage }}
				</p>
				<p v-if="successMessage" class="change-password__success-message">
					{{ successMessage }}
				</p>
				<BaseButton
					class="change-password__submit _btn-bordered"
					type="submit"
					:disabled="isSubmitting"
				>
					<span v-if="isSubmitting">{{ $t('Changing') }}...</span>
					<span v-else>{{ $t('Change password') }}</span>
				</BaseButton>
			</div>
		</form>
	</div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseInput from '@/components/base/BaseInput.vue';

export default {
	name: 'PasswordReset',
	components: { BaseInput, BaseButton },
	data() {
		return {
			isSubmitting: false,
			passwordData: {
				currentPassword: '',
				newPassword: '',
				confirmPassword: '',
			},
			errorMessage: '', // Store error messages from API
			successMessage: '', // Store success messages
		};
	},
	mounted() {
		this.isSubmitting = false;
	},
	methods: {
		async resetPassword() {
			this.isSubmitting = true;
			this.errorMessage = ''; // Clear previous errors
			this.successMessage = ''; // Clear success message

			try {
				const response = await this.$http.post(
					process.env.VUE_APP_API + 'user/change-password',
					{
						cur_password: this.passwordData.currentPassword,
						new_password: this.passwordData.newPassword,
						repeat_password: this.passwordData.confirmPassword,
					}
				);

				// If the API response status is OK, display success
				if (response.data.status === 'OK') {
					this.successMessage = this.$t('Password changed successfully!');
					this.clearForm();
					this.isSubmitting = false;
				}
			} catch (error) {
				if (error.response && error.response.data) {
					// Capture and display the API error message directly
					this.errorMessage =
						this.$t(error.response.data.message) ||
						'An unexpected error occurred.';
					this.isSubmitting = false;
				}
			}
		},
		clearForm() {
			this.passwordData.currentPassword = '';
			this.passwordData.newPassword = '';
			this.passwordData.confirmPassword = '';
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.change-password {
	&__form {
		@media (min-width: $md2) {
			display: flex;
			gap: 20px;
		}
	}
	&__inputs {
		@media (min-width: $md2) {
			flex: 1 1 100%;
		}
		@media (max-width: $md2) {
			&:not(:last-child) {
				@include adaptiveValue('margin-bottom', 15, 10);
			}
		}
	}
	&__input {
		width: 100%;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 10);
		}
	}
	&__wrapper {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		@media (min-width: $md2) {
			flex: 1 1 100%;
			max-width: 250px;
		}
	}
	&__error,
	&__success {
		font-family: var(--font-family-inter);
		font-size: 16px;
		line-height: 120%;
		font-weight: 500;
		display: block;
		text-align: center;
		margin-bottom: 8px;
	}
	&__error {
		color: var(--error-color);
	}
	&__success {
		color: var(--success-color);
	}
	&__submit {
		width: 100%;
		align-self: flex-end;
		line-height: 0;
		span {
			line-height: 120%;
			display: flex;
			align-items: center;
			min-height: 100%;
		}
	}
}
</style>
